<template>
  <a-spin :spinning="spinning">
    <a-form :form="form">
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom:0">
        <!-- 父级ID -->
        <a-input
          type="hidden"
          name="p_id"
          v-decorator="[
            'p_id',
            {
              rules: [{ required: true, message: 'p_id丢失' }],
              initialValue: pid
            }
          ]"
        />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-bottom:0" v-if="vid">
        <!-- 所属视频ID -->
        <a-input
          type="hidden"
          name="video_id"
          v-decorator="[
            'video_id',
            {
              rules: [],
              initialValue: vid
            }
          ]"
        />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="aid">
        <!-- 编辑 -->
        <a-input
          type="hidden"
          name="id"
          v-decorator="[
            'id',
            {
              rules: [{ required: true, message: 'ID丢失' }],
              initialValue: aid
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['title', { rules: [{ required: true, message: '请输入名称' }] }]" />
      </a-form-item>
      <a-form-item label="播放代码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input type="textarea" v-decorator="['play_code', { rules: [] }]" />
      </a-form-item>
      <a-form-item label="时长" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <time-picker
          :max-hours="100"
          placeholder="请选择时长"
          v-decorator="['date', { rules: [] }]"
        ></time-picker>
      </a-form-item>
      <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-switch
          checked-children="展示"
          un-checked-children="隐藏"
          name="state"
          v-decorator="[
            'state',
            {
              valuePropName: 'checked',
              initialValue: true
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input-number
          name="order"
          v-decorator="[
            'order',
            {
              initialValue: 0
            }
          ]"
        />
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { TimePicker } from '@/components'
import { requestGet, requestPost, requestPut } from '@/api/api'

const fields = ['title', 'order', 'play_code', 'date', 'state']
export default {
    name: 'ModelForm',
    props: {
        aid: {
            type: Number,
            default: null
        },
        pid: {
            type: Number,
            default: 0
        },
        vid: {
            type: [Number],
            default: null
        }
    },
    components: {
        TimePicker
    },
    data () {
        return {
            spinning: false, // 页面加载
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        if (this.$props.aid) {
            this.getInfo(this.$props.aid) // 获取编辑信息
        }
    },
    methods: {
        /**
         * 获取编辑信息
         * id
         * @param
         */
        getInfo (id) {
            this.spinning = true
            requestGet('/videos/collections/' + id)
                .then(res => {
                    res.result.state = res.result.state === 1
                    this.form.setFieldsValue(pick(res.result, fields))
                })
                .finally(() => {
                    this.spinning = false
                })
        },
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        if (this.$props.aid) {
                            // 有aid编辑，没aid创建
                            const url = '/videos/collections/' + this.$props.aid
                            requestPut(url, values)
                                .then(res => {
                                    this.$notification.success({
                                        message: res.msg
                                    })
                                    resolve(true) // 关闭弹出层
                                })
                                .catch(err => console.log(err))
                        } else {
                            requestPost('/videos/collections/create', values)
                                .then(res => {
                                    this.$notification.success({
                                        message: res.msg
                                    })
                                    resolve(true) // 关闭弹出层
                                })
                                .catch(err => console.log(err))
                        }
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
}
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>
